import { render } from "./BillOfMaterials.vue?vue&type=template&id=a0d926ee&scoped=true&ts=true"
import script from "./BillOfMaterials.vue?vue&type=script&lang=ts"
export * from "./BillOfMaterials.vue?vue&type=script&lang=ts"

import "./BillOfMaterials.vue?vue&type=style&index=0&id=a0d926ee&scoped=true&lang=css"

import exportComponent from "/Users/david/Documents/repos/fancypools-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0d926ee"]])

export default __exports__